// extracted by mini-css-extract-plugin
export default {"breadcrumbsContainer":"Breadcrumbs_breadcrumbsContainer__v5gbK","divider":"Breadcrumbs_divider__geQ5r","breadcrumbsLink":"Breadcrumbs_breadcrumbsLink__arurl"};